import {
    appendXSelectedCompanyHeader,
    fnSetDefaultToastr,
    getSelectedCompany,
    printToastrWarning
} from "./jquery-functions-library";
//Vouchers
import {clearVouchers} from "./voucher/clear-all";
import {fnClosePeriod} from "./voucher/close-period";
import {fnCloseSelectedVouchers} from "./voucher/close-selected-vouchers";
import {fnDeleteSelectedVouchers} from "./voucher/delete-selected-vouchers";
import {fnIgnoreSelectedVouchers} from "./voucher/ignore-selected-vouchers";
import {releaseVouchers} from "./voucher/release-all";
import {fnRemoveSelectedVouchers} from "./voucher/remove-selected-vouchers";
import {uploadPdfs} from "./voucher/upload-pdf";
import {fnUploadSelectedVouchers} from "./voucher/upload-selected-vouchers";
import {fnUploadBankStatement} from "./voucher/upload-statement";
import {fnUploadVoucher} from "./voucher/voucher-table";
import {fnVouchersEarlierReleasesActions} from "./voucher/vouchers-earlier-releases-actions";
import {fnVouchersEarlierReleasesTable} from "./voucher/vouchers-earlier-releases-table";
//Companies
import {fnSaveCustomerNumber} from "./companies/save-customer-number";
import {fnDatatableCompanies} from "./companies/companies-table";
//User Companies
import {fnUserCompaniesTable} from "./user-companies/user-companies";
//BI Companies
import {fnBiCompaniesTable} from "./bi-companies/bi-companies";
//Dashboard
import {fnDashboard} from "./dashboard/dashboard";
//Dashboard Admin
import {fnDashBustTableCache} from "./dashboard/admin/db-cache";
import {fnDashReloadOnDemand} from "./dashboard/admin/db-reload-on-demand";
import {fnDashMonthPicker} from "./dashboard/admin/db-month-picker";
import {fnDashGlobalSearch} from "./dashboard/admin/db-global-search";
import {fnDashDropdownFix} from "./dashboard/admin/db-dropdown-fix";
//Salary
import {fnCustomerEmployeesTable} from "./salary/customer-employees_table";
import {fnCustomerEmployeesStepsValidation} from "./salary/customer-employees_steps_validation";
import {fnTerminateEmployee} from "./salary/customer-employees_terminate";
import {fnCreateNewEmployee} from "./salary/customer-employees_create_new";
import {fnPayrollDataTable} from "./salary/payroll-data_table";
import {fnPayrollActivityDataTable} from "./salary/payroll-activity-data_table";
import {fnPayrollOptions} from "./salary/payroll-index";
import {fnPayrollNav} from "./salary/payroll-navigation";
import {fnDownloadSalaryInFormat} from "./salary/payroll-download-excel";
import {fnPayrollApproval} from "./salary/payroll-approval";
import {fnUnlockPayroll} from "./salary/payroll-unlock";
import {fnCalcPayrollEmployeeAmount} from "./salary/payroll-calc-amount";
import {fnDownloadEmployeesInFormat} from "./salary/employees-download-csv";
import {fnPaySlipsTable} from "./salary/pay_slips-table";
import {fnPaySlipDelete} from "./salary/pay_slips-delete";
import {fnPaySlipUpload} from "./salary/pay_slips-upload";
import {fnSalaryStatusTable} from "./salary/payroll-status";
import {fnFieldsCompanyTable} from "./salary/fields-company-table";
import {fnDisplayEmployeeChanges} from "./salary/employee-changes";
import {fnExportEmployeeChanges} from "./salary/employee-changes-export";
import {fnCustomerEmployeesPostalCodes} from "./salary/customer-employees_postal_codes";
//Screen
import {fnAdjustNavTabs} from "./screen/nav-tabs";
//Activities
import {fnActivitiesTable} from "./activities/activities-table";
//System
import {fnDataFieldTable} from "./system/datafields";
import {fnVatDeadlinesTable} from "./system/vat-deadlines";
import {fnSaveDropboxConfig} from "./system/save-dropbox-config";
//Holidays
import {fnHolidaysTable} from "./holidays/holidays-table";
import {fnHolidayActions} from "./holidays/actions";
//Work calendars
import {fnWorkCalendarsTable} from "./work-calendars/work-calendars-table";
import {fnWorkCalendarsActions} from "./work-calendars/actions";
//Task templates
import {fnTaskTemplatesTable} from "./task-templates/task-templates-table";
import {fnTaskTemplatesActions} from "./task-templates/actions";
//Company optionals
import {fnEmployeesOptionalsTable} from "./company/employees-optionals/employees-optionals-table";
import {fnEmployeesOptionalsActions} from "./company/employees-optionals/actions";
//Kube
import {fnKubeDataFieldsTable} from "./kube/data-fields-table";
import {fnKubeDataFieldActions} from "./kube/actions";
//Roles
import {fnRolesTable} from "./roles/roles-table";
import {fnRolesActions} from "./roles/actions";
//Economic period
import {fnEconomicPeriodTable} from "./economic-period/period-table";
//Translation
import {fnInitTranslationsManager} from "./translation/manager";
//General
import {uploadProfilePicture} from "./profile-picture";
import {fnSetActivePage} from "./highlight-active-page";
import {fnSidebarCloser} from "./sidebar-listener";
import {fnEditUser} from "./edit_user";
import {fnDatatable_users} from "./users-table";
import {fnEmployeeSettings} from "./employee-settings";
import {fnTableSettings} from "./table-settings";
import {fnCVR} from "./cvr";
//Power BI
import {fnPowerBI} from "./powerbi/powerbi";
//Roger AI
import {fnRogerAI} from "./roger-ai/roger-ai";
import {fnMarkSelectedVouchersAsMissing} from "./voucher/mark-selected-vouchers-as-missing";
import {fnViiaTable} from "./viia/table";
import {fnViiaTransactionsTable} from "./viia/transactions/table";
import {fnViiaTransactionTableFilters} from "./viia/transactions/filters";
import {fnViiaAccountsSelect} from "./viia/accounts-select";
import {fnViiaAttachToClient} from "./viia/attach-bank-to-client";
import {fnTogglePayslipsSent} from "./salary/payroll-status-toggle-sent";
import {fnToggleBenefits} from "./salary/customer-employees_toggle_benefits";

import {fnLoginToOutlay} from "./outlay/login";
import {fnConnectToOutlay} from "./outlay/connect";
import {fnCustomApprove} from "./custom-approve";
import {fnHolidayPayObligationsTable} from "./holiday-pay-obligations/table";
import {fnHolidayPayObligationsEntriesTable} from "./holiday-pay-obligations/entries/table";
import {fnHolidayPayObligationsUpload} from "./holiday-pay-obligations/upload";
import {fnHolidayPayObligationsExport} from "./holiday-pay-obligations/entries/export";
import {fnEmployeeUpload} from "./salary/upload-employees";
import {fnDownloadTemplate} from "./salary/customer-employees_download_template";


(function () {
    $(init);
    //$('#pjax-container').find('div.dataTables_scrollBody table.dataTable').resize();
})();

var pjax_called = false; // Executes on page load.

$(document).on('pjax:beforeSend', async function (event, xhr, options) {

    appendXSelectedCompanyHeader(xhr);
});

// $(document).on('pjax:error', function(event, xhr, textStatus, errorThrown, options) {
//     console.log(event);
//     console.log(xhr);
//     console.log(textStatus);
//     console.log(errorThrown);
//     console.log(options);
//     return false;
// });/*TODO*/


//TODO somehow handle
$(document).ajaxSend(async function (event, xhr, options) {
    appendXSelectedCompanyHeader(xhr);
});

$(document).ajaxError(function myErrorHandler(event, xhr, ajaxOptions, thrownError) {
    if(xhr.status === 409){//Company mismatch exception
        event.stopPropagation();
        window.location.reload();
    }
});

$(document).on('pjax:complete', function () {

    init();
    pjax_called = true; // Prevent the reload

    //noinspection JSAnnotator
    $('#material-design-container').bootstrapMaterialDesign({
        text: {
            selector: [`input:not([type=range]):not([type=hidden]):not([type=checkbox]):not([type=radio]):not([type=file]):not([type=button]):not([type=submit]):not([type=reset])`],
        },
    });
    $('#pjax-container').find('div.dataTables_scrollBody table.dataTable').resize();
    $('#pjax-container').find('div.dataTables_scrollBody table.dataTable').DataTable().draw();
});

function init() {
    $.pjax.defaults.timeout = 6000;
    $.pjax.defaults.maxCacheLength = 0;
    $('[data-toggle="tooltip"]').tooltip({delay: {show: 0, hide: 0}});

    //Needs to be loaded late to work with the datatables
    fnEmployeeSettings();

    fnCustomApprove();
    handleDataTablesAjaxError();
    handleAjaxErrors();
    fnSetDefaultToastr();
    fnSetActivePage();
    fnSidebarCloser();
    fnEditUser();
    uploadProfilePicture();
    uploadPdfs();
    releaseVouchers();
    clearVouchers();
    fnUploadVoucher();
    fnDeleteSelectedVouchers();
    fnRemoveSelectedVouchers();
    fnUploadSelectedVouchers();
    fnIgnoreSelectedVouchers();
    fnCloseSelectedVouchers();
    fnMarkSelectedVouchersAsMissing();
    fnClosePeriod();
    fnDatatableCompanies();
    fnSaveCustomerNumber();
    fnCustomerEmployeesTable();
    fnCustomerEmployeesStepsValidation();
    fnTerminateEmployee();
    fnInitTranslationsManager();
    fnUploadBankStatement();
    fnPayrollDataTable();
    fnPayrollActivityDataTable();
    fnTableSettings();
    fnDownloadSalaryInFormat();
    fnPayrollNav();

    fnDatatable_users();
    fnPayrollOptions();
    fnPaySlipsTable();
    fnPayrollApproval();
    fnCalcPayrollEmployeeAmount();
    fnCreateNewEmployee();
    fnPaySlipUpload();
    fnPaySlipDelete();
    fnSalaryStatusTable();
    fnTogglePayslipsSent();
    fnToggleBenefits();

    fnEmployeeUpload();

    fnAdjustNavTabs();
    fnDownloadEmployeesInFormat();

    fnFieldsCompanyTable();

    fnUserCompaniesTable();
    fnVatDeadlinesTable();
    fnSaveDropboxConfig();
    fnDataFieldTable();
    fnBiCompaniesTable();
    fnPowerBI();
    fnRogerAI();

    /*Dashboard Table v2*/
    fnDashBustTableCache();
    fnDashReloadOnDemand();

    fnDashMonthPicker();
    fnDashDropdownFix();

    fnDashboard();

    fnUnlockPayroll();

    fnActivitiesTable();

    fnDashGlobalSearch();

    fnHolidaysTable();
    fnHolidayActions();

    fnWorkCalendarsTable();
    fnWorkCalendarsActions();

    fnEmployeesOptionalsTable();
    fnEmployeesOptionalsActions();
    fnDownloadTemplate();

    fnKubeDataFieldsTable();
    fnKubeDataFieldActions();

    fnDisplayEmployeeChanges();
    fnExportEmployeeChanges();

    fnRolesTable();
    fnRolesActions();

    fnEconomicPeriodTable();

    fnCVR();

    fnCustomerEmployeesPostalCodes();

    fnTaskTemplatesTable();
    fnTaskTemplatesActions();

    fnVouchersEarlierReleasesTable();
    fnVouchersEarlierReleasesActions();

    fnViiaTable();
    fnViiaTransactionsTable();
    fnViiaTransactionTableFilters();
    fnViiaAccountsSelect();
    fnViiaAttachToClient();

    fnHolidayPayObligationsTable();
    fnHolidayPayObligationsEntriesTable();
    fnHolidayPayObligationsUpload();
    fnHolidayPayObligationsExport();

    /*Outlay*/
    fnLoginToOutlay();
    fnConnectToOutlay();
    /*Outlay*/

    $('.dataTables_filter > label > input[type=search]').each(function () {
        $(this).addClass('form-control')
    });
    $('.dataTables_filter label').find('input').addClass('form-control');
    $('.dataTables_length label').find('select').addClass('form-control');
}

function handleDataTablesAjaxError() {
    $.fn.dataTable.ext.errMode = function (settings, helpPage, message) {
        // console.log(settings);
        // console.log(helpPage);
        // console.log(message);
        var lang = allLangFiles.forms;
        var currentErrorMessage = lang.generic_error + ' ' + lang.possibly + ' ' + lang.unauthorized;
        printToastrWarning(currentErrorMessage);
    };
}

function handleAjaxErrors() {
    $(document).ajaxError(function (event, jqxhr, settings, thrownError) {

        try {
            var jsonResponse = $.parseJSON(jqxhr.responseText);
            var error = jsonResponse.error;

            if (error == 'Unauthenticated.') {
                window.location.reload();
            }
        } catch (e) {
            if (jqxhr.responseText && jqxhr.responseText.indexOf('TokenMismatchException') !== -1) {
                window.location.reload();
            }
        }
    });
}
